(() => {
  angular
    .module('gm.common.decorators', []);
})();
